require("../css/ui.css")

document.addEventListener("DOMContentLoaded", () => {
  console.log("DOMContentLoaded", "Multispin")
})
